module.exports = __webpack_public_path__ + "img/ic_24_login.71c83de7.svg";